import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-373f592b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "main" }
const _hoisted_2 = { class: "swiper-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper_navi = _resolveComponent("swiper-navi")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper, { onSlideChange: _ctx.onSlideChange }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: index,
              class: _normalizeClass({ active: index === 0 })
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(content.title), 1),
                (_ctx.mobile)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: require(`@/assets/img/info/${content.mobileImage}`)
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: require(`@/assets/img/info/${content.image}`)
                    }, null, 8, _hoisted_5)),
                (content.text)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      innerHTML: content.text
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128)),
          (_ctx.step > 0)
            ? (_openBlock(), _createBlock(_component_swiper_navi, {
                key: 0,
                ref: "prevButton",
                isNext: false,
                onSwipe: _ctx.prev,
                class: "prev"
              }, null, 8, ["onSwipe"]))
            : _createCommentVNode("", true),
          _createVNode(_component_swiper_navi, {
            ref: "nextButton",
            isNext: true,
            onSwipe: _ctx.next,
            onEnd: _ctx.enter,
            class: _normalizeClass(["next", { first: _ctx.step === 0 }])
          }, null, 8, ["onSwipe", "onEnd", "class"])
        ]),
        _: 1
      }, 8, ["onSlideChange"]),
      _createElementVNode("button", {
        class: "skip",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enter && _ctx.enter(...args)))
      })
    ])
  ], 512))
}